export enum StatusAssinatura {
  LOTE_NAO_GERADO = 'LOTE_NAO_GERADO',
  AGUARDANDO_LOTE = 'AGUARDANDO_LOTE',
  LOTE_GERADO = 'LOTE_GERADO',
  CLIENTE_NOTIFICADO = 'CLIENTE_NOTIFICADO',
  FALHA_DOWNLOAD_DOC = 'FALHA_DOWNLOAD_DOC',
  DOCUMENTO_AUSENTE = 'DOCUMENTO_AUSENTE',
  TP_DOCUMENTO_NAO_ENCONTRADO = 'TP_DOCUMENTO_NAO_ENCONTRADO'
}
